import { API } from '@/shared/api/modules';
import { queryOptions } from '@tanstack/react-query';

export const getFacilitiesOptionsQueryOptions = queryOptions({
  queryKey: ['facilities-options'],
  staleTime: 60 * 1000, // 1 minute
  queryFn: async ({ signal }) => {
    const response = await API.facilities.getFacilitiesOptions({ signal });

    return response.map(({ id, name }) => ({
      value: String(id),
      label: name,
    }));
  },
});
